﻿<script>
	import { getContext } from 'svelte';

    import { registerPageComplete } from "../tealium";
    import { pageNumber, currentPage } from '../stores/pageStore';
	import model from "../stores/modelStore";
	import lookups from "../stores/lookupStore";
	import textStore from "../stores/textStore";
	import { isValid } from "../validation";

    import PageSection from "../components/PageSection.svelte"
	import Form from "../components/Form.svelte";
	import FormRow from "../components/FormRow.svelte";
	import FormColumn from "../components/FormColumn.svelte";
	import YesNoGroup from "../components/YesNoGroup.svelte";
	import Select from "../components/Select.svelte";
	import Input from "../components/Input.svelte";
	import TextArea from "../components/TextArea.svelte";
    import NavigationButtons from "../components/NavigationButtons.svelte"

    export let disabled;
    
    let buttons;
	const { displayError } = getContext("error-modal");

	const handleSubmit = async (e) => {
        //e.preventDefault();
        buttons.blockNext();

		if (isValid()) {
            // Reset values as required
            if($model.HasQualifications === "False") {
                $model.QualificationDetails = null;
            }
            if($model.ReturnedToWork === "False") {
                $model.ReturnedToWorkDetails = null;
            }

			registerPageComplete("Education, Training and Experience",
				$model.Contact.EmailAddress,
				$model.Contact.PhoneNumber,
				$model.ReferralSource);

			let response = await model.saveModelAsync();

			if (!response.success) {
				console.log(displayError)
				displayError(response);
			} else {
				buttons.next();
			}
		}

		buttons.unblock();
		return true;
	};

	$pageNumber = ($currentPage ? $currentPage.pageIndex : 0);

</script>

<PageSection>

	<Form {disabled} id="education-details" on:submit={handleSubmit}>

		<h1>Education</h1>

		<FormRow>
			<FormColumn cols="4">
				<Select {disabled}
					id="educationLevel"
					label="What {$textStore.isYourLower} highest level of school education?"
					optionList={$lookups.EducationOptions}
					bind:value={$model.EducationLevel}
				/>
			</FormColumn>
		</FormRow>
		
	    <FormRow>
		    <FormColumn cols="12">
			    <YesNoGroup {disabled}
				    label="{$textStore.doYou} have any qualifications, licences, tickets etc?"
				    name="hasQualifications"
				    bind:value="{$model.HasQualifications}" />
		    </FormColumn>
	    </FormRow>
		
		{#if $model.HasQualifications === "True"}
			<FormRow>
				<FormColumn>
					<TextArea
						{disabled}
						label="If yes, please provide details below:"
						id="qualificationDetails"
						maxlength="255"
						rows="2"
						bind:value={$model.QualificationDetails}
					/>
				</FormColumn>
			</FormRow>
		{/if}

		<h1>Employment</h1>
		
		<FormRow>
			<FormColumn>
				<Input
					{disabled}
					label="Employer/Business Name at the time {$textStore.you} ceased working"
					id="employerName"
					maxlength="255"
					bind:value={$model.BusinessNameWhenNoWork}
				/>
			</FormColumn>
		</FormRow>
		
		<FormRow>
			<FormColumn>
				<Input
					{disabled}
					label="What was {$textStore.your} Job Title?"
					id="jobTitle"
					maxlength="255"
					bind:value={$model.JobTitle}
				/>
			</FormColumn>
		</FormRow>
				
	    <FormRow>
		    <FormColumn cols="12">
			    <YesNoGroup {disabled}
				    label="{$textStore.haveYou} returned to any work since {$textStore.they} stopped work because of {$textStore.their} injury or illness?  "
				    name="returnedToWork"
				    bind:value="{$model.ReturnedToWork}" />
		    </FormColumn>
	    </FormRow>

		{#if $model.ReturnedToWork === "True"}
			<FormRow>
				<FormColumn>
					<TextArea
						{disabled}
						label="If yes, please provide details below:"
						id="returnedToWorkDetails"
						maxlength="255"
						rows="2"
						bind:value={$model.ReturnedToWorkDetails}
					/>
				</FormColumn>
			</FormRow>
		{/if}

		{#if (!disabled)}
			<div class="form-group form-row">
				<div class="col-md-12 last">
					<NavigationButtons bind:buttons={buttons} />
				</div>
			</div>
		{/if}
	</Form>
</PageSection>